import state from './moduleZonesState'
import mutations from './moduleZonesMutations'
import actions from './moduleZonesActions'
import getters from './moduleZonesGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
